import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import EditorConditionLink from './EditorConditionLink';
import ConditionRestrictedAsset from './../common/ConditionRestrictedAsset';
import EditorAssetAndPropertySelect from './EditorAssetAndPropertySelect';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorConditionAsset = props => {
  const {
    filterFamily,
    condition,
    onAssetChange
  } = props;
  const {
    getAssetTypeLabelToken
  } = useTranslationHelpers(filterFamily);
  const resourceTypeLabelToken = getAssetTypeLabelToken();

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  if (condition.field && condition.field.userHasNoAccess) {
    return /*#__PURE__*/_jsx(ConditionRestrictedAsset, {
      filterFamily: filterFamily
    });
  }
  if (onAssetChange && condition.field) {
    return /*#__PURE__*/_jsx(EditorAssetAndPropertySelect, {
      field: condition.field,
      filterFamily: filterFamily,
      onChange: onAssetChange
    });
  }
  const linkLabelToken = `newCustomerDataFilters.useTranslationHelpers.linkLabels.${resourceTypeLabelToken}_jsx`;
  return /*#__PURE__*/_jsx(EditorConditionLink, {
    condition: condition,
    filterFamily: filterFamily,
    linkLabel: linkLabelToken
  });
};
export default EditorConditionAsset;